<template>
    <div class="root_page_center wrapper_bank">
        <div class="wp_bank">
            <!-- modal Noty -->
            <div class="modalRedirect" v-if="showmodal">
                <div class="content_modalredirect content_modalredirects content_modalredirectss">
                    <p @click="showmodal = false" class="closeMdredirect">
                        <img src="../assets/images/close.png" @click="showmodal = false" alt="">
                    </p>
                    <h3 class="titleMd_qr">{{ notyEnd }}</h3>
                    <router-link to="/">
                        <button type="button">Quay lại</button>
                    </router-link>
                </div>
            </div>
            <!-- Vietcombank -->
            <div class="rootBank rootBank_1" v-if="idBank == 9" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/vcb1.png" alt="">
                    <div class="contentbankVcb">
                        <img src="../assets/images/bank/vcb2.png" alt="">
                        <h3 class="fullnameVcb">{{ fullName }}</h3>
                        <h4 class="stkVcb">{{ stk }}</h4>
                        <p class="moneyVcb">{{ money }} VNĐ</p>
                    </div>
                </div>
            </div>
            <!-- MSB Bank -->
            <div class="rootBank rootBank_2" v-if="idBank == 10" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/msb1.png" alt="">
                </div>
                <h3 class="fullnameMsb">{{ fullName }}</h3>
                <p class="moneyMsb">{{ money }} VNĐ</p>
            </div>
            <!-- TP Bank -->
            <div class="rootBank rootBank_3" v-if="idBank == 11" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/tpb1.png" alt="">
                </div>
                <h3 class="fullnameTpb">{{ fullName }}</h3>
                <h4 class="stkTpb">{{ stk }}</h4>
                <p class="moneyTpb">{{ money }} VNĐ</p>
            </div>
            <!-- PVCom Bank -->
            <div class="rootBank rootBank_4" v-if="idBank == 12" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/pvc1.png" alt="">
                </div>
                <h3 class="fullnamePvc">{{ fullName }}</h3>
                <p class="numberBankUser">{{ stk }}</p>
                <p class="moneyPvc">{{ money }} VNĐ</p>
            </div>
            <!-- SacomBank -->
            <div class="rootBank rootBank_5" v-if="idBank == 14" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/scb2.png" alt="">
                </div>
                <p class="moneyScb">{{ money }} đ</p>
            </div>
            <!-- NCB Bank -->
            <div class="rootBank rootBank_6" v-if="idBank == 16" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/ncb1.png" alt="">
                </div>
                <h3 class="fullnameNcb">{{ fullName }}</h3>
                <p class="moneyNcb">{{ money }} VNĐ</p>
            </div>
            <!-- OCB Bank -->
            <div class="rootBank rootBank_7" v-if="idBank == 17" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/ocb1.png" alt="">
                </div>
                <h3 class="fullnameOcb">{{ fullName }}</h3>
                <p class="moneyOcb">{{ money }} VNĐ</p>
            </div>
            <!-- VIB -->
            <div class="rootBank rootBank_8" v-if="idBank == 18" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/vib1.png" alt="">
                </div>
                <p class="moneyVib">{{ money }} đ</p>
            </div>
            <!-- TechcomBank -->
            <div class="rootBank rootBank_9" v-if="idBank == 26" @click="showMdalNoty()">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/tcb1.png" alt="">
                </div>
                <div class="contentTcb">
                    <img src="../assets/images/icontcb.png" alt="">
                    <div class="nameNumberTcb">
                        <p class="moneyTcb0">Số dư hiện có</p>
                        <p class="moneyTcb">{{ money }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'Result_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            idBank: window.localStorage.getItem('idbank'),
            fullName: '',
            money: '',
            showPassword: '',
            showmodal: false,
            notyEnd: '',
            stk: ''
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.getDataListInfo()
        this.getDataBank()
    },
    beforeUnmount () {

    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullName = response.data.data.name
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        getDataBank () {
            this.axios.get(this.api_bankMoney + '?bank_id=' + this.idBank,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.money = Number(response.data.data.money).toLocaleString('vi-VN')
                this.stk = response.data.data.number_bank
            })
        },
        showMdalNoty () {
            $('#loadingBgr').show().fadeIn(10)
            this.axios.get(this.api_dialogBank,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                $('#loadingBgr').css('display', 'none')
                this.showmodal = true
                this.notyEnd = response.data.data.content
            })
        },
    }
}
</script>